/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { Editor } from "@tiptap/react";
import { BsCheckLg } from "react-icons/bs";
import StrikethroughIcon from "../../../../assets/icon/CampaignNotesToolbar/strikethrough-icon";
import UnderlineIcon from "../../../../assets/icon/CampaignNotesToolbar/underline-icon";
import ChecklistItem from "./ChecklistItem";
import {
  handleParagraph,
  handleStrikethrough,
  handleUnderline,
  isElementActive,
} from "./toolbarUtils";
import TopBarItem from "./TopBarItem";

const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  cursor: auto;

  left: -5px;
  top: 50px;

  width: 160px;

  background-color: #fff;
  border: 1px solid #ededed;
  border-radius: 4px;

  z-index: 99991;

  box-shadow: 0px 2px 5px #00000026;
  color: #333333 !important;

  :after {
    content: "";
    position: absolute;
    display: block;
    border-style: solid;
    border-color: #fff transparent;

    border-width: 9px 7px 0;
    top: -9px;
    left: 14px;
    transform: rotate(180deg);
    width: 0;
    z-index: 1;
  }

  :before {
    content: "";
    position: absolute;
    border-style: solid;
    border-color: #ededed transparent;
    display: block;

    border-width: 10px 8px 0;
    top: -10px;
    left: 13px;
    transform: rotate(180deg) translateY(0.5px);
    width: 0;
    z-index: 1;
  }
`;

const TopbarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 50px;

  border-bottom: 1px solid #ededed;
`;

const ItemContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  grid-gap: 8px;

  width: 100%;
  height: fit-content;

  padding: 0 8px;
`;

const ChecklistContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  padding: 8px;
  width: 100%;
`;

interface INotePopoverFormatting {
  editor: Editor;
}

export default function NotePopoverFormatting({
  editor,
}: INotePopoverFormatting) {
  return (
    <Container>
      <TopbarContainer>
        <ItemContainer>
          {[
            {
              handler: handleUnderline,
              icon: <UnderlineIcon />,
              type: "underline",
            },
            {
              handler: handleStrikethrough,
              icon: <StrikethroughIcon />,
              type: "strike",
            },
          ].map(({ handler, icon, type }) => (
            <TopBarItem
              key={type}
              onClick={() => {
                if (!editor.isFocused) return;
                handler(editor);
              }}
              isActive={isElementActive(type as any, editor)}
            >
              {icon}
            </TopBarItem>
          ))}
        </ItemContainer>
      </TopbarContainer>

      <ChecklistContainer>
        {[
          {
            handler: handleParagraph,
            className: "p",
            label: "Body",
            type: "paragraph",
          },
        ].map(({ handler, className, label, type }) => (
          <ChecklistItem
            key={className}
            className={className}
            onClick={() => {
              if (!editor.isFocused) return;
              handler(editor);
            }}
            isActive={editor.isActive(type || "heading")}
          >
            <BsCheckLg className="icon" />
            {label}
          </ChecklistItem>
        ))}
      </ChecklistContainer>
    </Container>
  );
}
